(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-badges"] && !Shopify.designMode) return;
  try {
    (function() {
    function parseFrDate(str) {
      // Format: DD/MM/YYYY HH:MM
      var parts = str.split(' ');
      if (parts.length < 2) return null;
      var dateParts = parts[0].split('/');
      var timeParts = parts[1].split(':');
      if (dateParts.length < 3 || timeParts.length < 2) return null;
      return new Date(
        parseInt(dateParts[2]),
        parseInt(dateParts[1]) - 1,
        parseInt(dateParts[0]),
        parseInt(timeParts[0]),
        parseInt(timeParts[1])
      );
    }

    function updateCountdowns() {
      var els = document.querySelectorAll('.cz-flash-countdown[data-end]');
      var now = Date.now();
      els.forEach(function(el) {
        var end = parseFrDate(el.dataset.end);
        if (!end) return;
        var diff = end.getTime() - now;
        var span = el.querySelector('.cz-countdown-text');
        if (!span) return;
        if (diff <= 0) {
          span.textContent = '⏱ Terminé';
          return;
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        span.textContent = '⏱ ' + String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      updateCountdowns();
      setInterval(updateCountdowns, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
